import { render, staticRenderFns } from "./serviceForm.vue?vue&type=template&id=cccc5314&scoped=true"
import script from "./serviceForm.vue?vue&type=script&lang=js"
export * from "./serviceForm.vue?vue&type=script&lang=js"
import style0 from "./serviceForm.vue?vue&type=style&index=0&id=cccc5314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccc5314",
  null
  
)

export default component.exports